import React, { useState } from "react";
import { DashboardPage } from "../Components/account/DashboardPage";
import CommonAppShell from "../Components/CommonAppShell";

function Dashboard(): JSX.Element {
  const [refresh, setRefresh] = useState(false);
  const handleDomainAdded = () => setRefresh((prev) => !prev);
  return (
    <CommonAppShell sidebarLabel="dashboard" style={{ background: "#f2f4fa" }} padding="md" isSidebar={true}>
      <DashboardPage onDomainAdded={handleDomainAdded} refresh={refresh} />
    </CommonAppShell>
  );
}

export { Dashboard };
